module.exports = __webpack_public_path__ + "img/213.01e98e42.jpg";